import { Spin } from "antd";
import React from "react";

const PageLoading: React.FC = () => (
  <div style={{ paddingTop: 100, textAlign: "center" }}>
    <Spin size="large" delay={500} />
  </div>
);

export default PageLoading;
